import { styled } from 'solid-styled-components';
import theme, { palette } from '../../style/theme';
import { userProfileGridStyle } from '../user-profile-menu/user-profile-menu-desktop/user-profile-menu-desktop.styles';

export const StyledCategoriesContainer = styled.div<{ filterBgColor?: string }>`
    display: flex;
    align-items: flex-end;
    position: relative;
    padding: 2.2rem 0;
    border-radius: 1.43rem;
    background: ${p => p.filterBgColor ? p.filterBgColor : palette.lightBeige};
    padding: 2rem 3rem;
`;

export const StyledCategoriesHeadingDesktop = styled.div`
    align-self: flex-start;
    padding-right: 2rem;
    flex-shrink: 0;
`;

export const StyledCategoriesContainerMobile = styled.div`
    position: relative;
    padding: 2.2rem 0;
`;

export const StyledCategoriesList = styled.ul`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-left: ${theme.spacing.s};

    @media only screen and (max-width: ${700}px) {
        margin-left: 0;
    }

    ${theme.mediaQueries.mobileMax} {
        margin-left: unset;
        display: block;
    }
`;

export const StyledCategoryItem = styled.button<any>`
    margin-left: ${theme.spacing.s};
    cursor: pointer;
    list-style: none;
    padding: 0 1rem;
    padding-bottom: 0.5rem;
    padding-top: 0.3rem;

    ${(props) =>
        props.underlined &&
        `
        text-decoration: underline;
        text-decoration-color: ${theme.colors.text.red};
    `}

    ${theme.mediaQueries.mobileMax} {
        margin-left: 0;
        border-top: 1px solid ${palette.gray};
        padding: 1.5rem 0;
    }
`;


export const StyledShowMoreButtonContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export const StyledMyContentGrid = styled.div`
    ${userProfileGridStyle}
`;

export const StyledMyContentSection = styled.div`
    container-type: inline-size;
    margin-top: 2rem;
    margin-bottom: 2rem;
`;
